// @flow

import React from 'react';
import FullContentCarousel from './FullContentCarousel';
import FullContentNumbers from './FullContentNumbers';
import TemplateBlock from './TemplateBlock';
import CarouselMedia from './CarouselMedia';
import ParalaxScroller from '../../../../components/paralaxScroller/ParalaxScroller';
import MenuPage from '../../../../components/paralaxScroller/MenuPage';
import type { MarketingTemplate } from '../../../../types/marketingType';

type Props = {
  data: MarketingTemplate[],
  scrollRef: HTMLDivElement,
}

const templateNames = {
  FULLCONTENT: 'FULLCONTENT',
  BLOCK: 'BLOCK',
  MEDIA: 'MEDIA',
};

function MarketingTab({ data, scrollRef }: Props) {
  return (
    <div className="marketing-brand-event scrollable-content">
      <ParalaxScroller
        scrollableElement={scrollRef}
      >
        {
          data.sort((a, b) => a.position - b.position).map((template) => {
            let elt;
            if (template.templateName === templateNames.FULLCONTENT && template.medias) {
              elt = <FullContentCarousel data={template} />;
            }
            if (template.templateName === templateNames.FULLCONTENT && template.marketingMainNumbers) {
              elt = <FullContentNumbers data={template} />;
            }
            if (template.templateName === templateNames.BLOCK) {
              elt = <TemplateBlock data={template} />;
            }
            if (template.templateName === templateNames.MEDIA) {
              elt = <CarouselMedia data={template} />;
            }
            return (
              <MenuPage key={`page${template.id}`} id={template.id}>
                {elt}
              </MenuPage>
            );
          })
        }
      </ParalaxScroller>
    </div>
  );
}

export default MarketingTab;
